export default "__VITE_ASSET__$t_QaWVs__"